export default __webpack_public_path__ + "static/media/home-tab-icon.f969de58.svg";